module.exports = __webpack_public_path__ + "static/media/wrong-answer.c7106542.mp3";